import type { RouteObject } from 'react-router-dom'

const masterDataRoute: RouteObject = {
  children: [{ lazy: () => import('@/pages/master-data/page'), path: '' }],

  path: 'master-data',
}

export default masterDataRoute
